import { request } from "../request";
const mock = "";

// 获取地址列表
export const getAddressList = (params) =>
  request(`${mock}/v1/user/address/list`, "get", { params });
// 删除地址
export const deleteAddress = (params) =>
  request(`${mock}/v1/user/address/del`, "post", { json: params });
// 保存地址
export const saveAddress = (params) =>
  request(`${mock}/v1/user/address/save`, "post", { json: params });
